import styled from "styled-components"

const Flex = styled.div`
  display: flex;
  justify-content: ${(props) => props.justify || "start"};
  align-items: ${(props) => props.align || "start"};
  flex-direction: ${(props) => props.direction || "row"};
  gap: ${(props) => props.gap || "1"}rem;
  ${(props) => props.css};
`

export default Flex
